import { GetTokenSilentlyOptions, LogoutOptions } from '@auth0/auth0-react';
import { PostHog } from 'posthog-js';
import { isItemReferences } from './LearnosityFetchError';
import { fetchLearnosityStartupData, type LearnosityFetchOptions } from './fetchLearnosityStartupData';

export const getItemReferences = async (
  url: string,
  getAccessTokenSilently: (options: GetTokenSilentlyOptions) => Promise<string>,
  logout: (options?: LogoutOptions) => Promise<void>,
  posthog: PostHog,
  options: LearnosityFetchOptions = {},
): Promise<string[]> => {
  return fetchLearnosityStartupData(
    {
      operation: 'get_item_references',
      path: `/v1/learnosity/item-references/${url}`,
      fields: { activityReference: url },
      validate: isItemReferences,
    },
    getAccessTokenSilently,
    logout,
    posthog,
    options,
  );
};
